import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './slices/AuthSlice';
import systemStatusReducer from './slices/SystemStatusSlice';

const CommonReducer = combineReducers({
  auth: authReducer,
  systemStatus: systemStatusReducer,
});
export type AuthState = ReturnType<typeof CommonReducer>;
export default CommonReducer;
